import React, { useState } from 'react';
import {
    Button,
    DialogTitle,
    DialogContent,
    DialogActions,
    LinearProgress
} from '@mui/material';


import { DialogoBoostrap } from './DialogoPersonalizado/DialogoBoostrap';

import { useGlobalState } from '../../Utilidades/useGlobalState';

import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

//styles
import {
    modalesMensajesGenericos
} from '../Tool/Style';

let funcionCargarModal;
let validaCargaModal;
let funcionLoadingModal;

export const DialogoEliminarGenerico = ({ deviceIs = "DESKTOP", TextoElementoEliminar, funcionEliminar }) => {

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

    const [loading, setLoading] = useState(false);// se encarga del cargando del modal

    const { etiquetas } = useGlobalState();

    const [cargaEliminar, setCargaEliminar] = useState(false);
    funcionCargarModal = setCargaEliminar;
    validaCargaModal = cargaEliminar;
    funcionLoadingModal = setLoading;

    return (
        <DialogoBoostrap
            onClose={mostrarDialogoEliminarGenerico}
            aria-labelledby="customized-dialog-title"
            open={cargaEliminar}
            fullScreen={fullScreen}
            sx={deviceIs === "MOBILE" ? { margin:"6px", height:  "256px", top:'32%'}: undefined}
            maxWidth="sm"
            fullWidth>
            {loading ? <LinearProgress></LinearProgress> : null}
            <DialogTitle>
                {etiquetas.General.Et_TituloEliminaRegistro}
            </DialogTitle>

            <DialogContent dividers style={{ backgroundColor: modalesMensajesGenericos.BotonesNo.backgroundColor}}>
                {etiquetas.General.TextoEliminarRegistro} <br />
                <span style={{ color: modalesMensajesGenericos.CuerpoModal.color }}>{TextoElementoEliminar}</span>
            </DialogContent>

            <DialogActions style={{ justifyContent: 'right', margin: '5px' }} >
              
                <Button
                    disabled={loading}
                    style={modalesMensajesGenericos.BotonesNo}
                    variant="outlined"
                    onClick={mostrarDialogoEliminarGenerico}>
                    { deviceIs === "MOBILE" ? etiquetas.General.Et_tbnCancelar :  etiquetas.General.Et_tbnMantenerRegistro}
                </Button>

                <Button
                    style={modalesMensajesGenericos.BotonesOk }
                    disabled={loading}
                    variant="outlined"
                    onClick={() => {
                        setLoading(true);
                        funcionEliminar();
                        setLoading(false);
                    }}>
                    {etiquetas.General.Et_tbnEliminarRegistro}
                </Button>

            </DialogActions>
        </DialogoBoostrap>
    );
}

export const mostrarDialogoEliminarGenerico = () => {
    funcionCargarModal(!validaCargaModal);
    if (validaCargaModal === false) {
        funcionLoadingModal(false);
    }
}